<template>
    <!-- <div class="services-first-text">
        <div v-if="this.item.url" class="inner-text">
            <router-link v-if="!isExternalLink" v-bind:to="computeRoute">
                <h2>{{ item.title }}</h2>
            </router-link>
            <a v-else v-bind:href="item.url" target="_blank">
                <h2>{{ item.title }}</h2>
            </a>
        </div>
        <router-link v-else :to="{ name: 'menuDetailsNew', params: { id: item.id, slug: item.slug } }"
            v-bind:key="item.id">
            <h2>{{ item.title }}</h2>
        </router-link>
    </div> -->
<div class="highlighted-routes">
    <router-link v-if="this.item.url && !isExternalLink" v-bind:to="computeRoute">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </router-link>

    <a v-else-if="this.item.url" v-bind:href="item.url" target="_blank">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </a>

    <router-link v-else :to="{ name: 'menuDetailsNew', params: { id: item.id, slug: item.slug } }" v-bind:key="item.id">
        <div class="services-first-text">
            <h2>{{ item.title }}</h2>
        </div>
    </router-link>
</div>
 
</template>

<script>
import { mapGetters, mapActions } from "vuex"

export default {
    props: ["id"],
    name: "AppHighlightedServicesCard",
    data() {
        return {
            item: null,
            htmlContent: ""
        }
    },
    methods: {
        ...mapActions(["fetchContentById"]),
        loadData() {
            this.fetchContentById(this.id).then((contentResposnse) => {
                if (contentResposnse) {
                    this.item.title = contentResposnse.title;
                    this.item.url = contentResposnse.url;
                    this.item.slug = contentResposnse.slug;
                    this.htmlContent = contentResposnse.content;
                }
            });
        },
    },
    computed: {
        ...mapGetters(["getContentById", "getContentTypes", "getSelectedLanguage"]),
        isExternalLink() {
            return (this.item.url != null && ((this.item.contentTypeId == this.getContentTypes.linkContentTypeId && this.item.url.startsWith("http")) ||
                (this.item.contentTypeId == this.getContentTypes.highlightedServicesTypeId && this.item.url.startsWith("http"))));
        },
        isInternalLink() {
            return (this.item.url != null && ((this.item.contentTypeId == this.getContentTypes.linkContentTypeId && !this.item.url.startsWith("http")) ||
                (this.item.contentTypeId == this.getContentTypes.highlightedServicesTypeId && !this.item.url.startsWith("http"))));
        },
        computeRoute() {
            return this.isInternalLink ? { name: this.item.url } : { name: 'contentNew', params: { id: this.item.id, slug: this.item.slug } };
        },
    },
    created() {
        this.item = this.getContentById(this.id);
        this.loadData();
    },
    watch: {
        getSelectedLanguage() {
            this.loadData();
        },
    },
}
</script>

<style scoped>
.highlighted-routes{
    height: 100%;
    width: 100%;
}

.highlighted-routes a{
    height: 100%;
    width: 100%;
    text-decoration: none;
}

.highlighted-routes a:hover{
    text-decoration: none;
}

.services-first-button {
    background-color: transparent;
    border: none;
    align-items: end;
    float: right;
}

.services-first-button i {
    font-size: 40px;
    color: white;
}

.inner-text {
    align-self: center;
    width: 100%;
}

.services-first-text {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;

}

.services-first-text h2 {
    /* font-size: 30px; */
    font-size: 30px;
    color: #fff;
    font-weight: 600;
    /* margin-bottom: 15px; */
    margin-bottom: 0;
    text-transform: uppercase;
    /* letter-spacing: 0px; */
    margin-left: 5px;
    margin-right: 5px;
}

.services-first-text-p {
    max-height: 300px;
    color: var(--light-color);
    text-align: justify;
    font-size: 18px;
    line-height: 1.8;
    /* margin-bottom: 20px; */
    padding-right: 15px;
}

.services-first-text router-link {
    text-decoration: none;
}

.services-first-text:hover router-link,
.services-first-text:hover a {
    text-decoration: none;
}

.services-first-text-p a {
    color: var(--light-color);
    text-decoration: underline;
    font-weight: bold;
}

.services-first-text-p a:hover {
    color: #ffcc00;
}
</style>
